import React from "react";
import { buildRoutes } from "@app/routes/RouteBuilder";
import lazyWithRetry from "@shared/utils/lazyWithRetry";

// Lazy loading con retry automático
const Pendientes = lazyWithRetry(
  () => import("./ui/PendientesRefactored"),
  "Pendientes",
);

/**
 * Rutas de pendientes
 */
const pendientesRoutes = buildRoutes([
  {
    path: "/pendientes",
    element: Pendientes,
    roles: [1, 2, 5, 7],
  },
]);

export default pendientesRoutes;
